// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import SearchTextField, { SearchTextFieldStyles } from "@store/Library/Widgets/ShipmentHistory/SearchTextField";
import * as React from "react";

export const orderNumberStyles: SearchTextFieldStyles = {};
const styles = orderNumberStyles;

const ShipmentHistorySearchByItemNumber: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            styles={styles}
            parameterField="itemNumber"
            label={translate("Item #")}
            inputType="text"
            placeholder=""
            testSelector="shipmentHistory_ItemNumber"
        />
    );
};

const widgetModule: WidgetModule = {
    component: ShipmentHistorySearchByItemNumber,
    definition: {
        group: constants.widgetGroup.shipmentHistory,
        allowedContexts: [constants.pageType.shipmentHistory],
        displayName: "Item #",
    },
};

export default widgetModule;
